<template>
  <div id="home">
    <div class="hero-section">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7">
            <p class="eyebrow">Professional web design and development</p>
            <h1>Modern websites built to grow your business.</h1>
            <p class="lead">
              IMEJ Tech creates polished, responsive websites for professionals,
              creatives, and growing companies who want a stronger online presence.
            </p>
            <div class="hero-actions">
              <router-link to="/Contact" class="btn btn-primary btn-lg"
                >Book a Free Consultation</router-link
              >
              <router-link to="/Portfolio" class="btn btn-outline-light btn-lg"
                >View Portfolio</router-link
              >
            </div>
          </div>
          <div class="col-lg-5">
            <div class="info-card">
              <h3>What you can expect</h3>
              <ul>
                <li>Custom design tailored to your brand</li>
                <li>Fast, mobile-friendly websites</li>
                <li>Clear messaging and strong calls to action</li>
                <li>Support from planning to launch</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container content-section">
      <div class="row">
        <div class="col-md-6 col-lg-3 mb-4">
          <div class="service-card">
            <img src="../assets/ai-pic4.png" alt="Website design" />
            <h4>Custom Design</h4>
            <p>Clean layouts and thoughtful structure that reflect your brand.</p>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 mb-4">
          <div class="service-card">
            <img src="../assets/ai-pic3.png" alt="Responsive development" />
            <h4>Responsive Development</h4>
            <p>Websites that look polished and perform well on every device.</p>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 mb-4">
          <div class="service-card">
            <img src="../assets/ai-pic5.png" alt="Website platforms" />
            <h4>Platform Flexibility</h4>
            <p>Built from scratch, on Squarespace, or on WordPress based on your needs.</p>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 mb-4">
          <div class="service-card">
            <img src="../assets/screen-3.png" alt="Consultation" />
            <h4>Strategic Support</h4>
            <p>Clear guidance from discovery through launch and beyond.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  props: {
    msg: String,
  },
};
</script>

<style scoped>
#home {
  display: flex;
  flex-direction: column;
  background-image: url("../assets/screen-5.png");
  background-size: cover;
  background-position: center;
  animation: backgroundMove 200s ease-in-out infinite;
}
.hero-section {
  padding: 80px 0;
  color: white;
}
.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.2em;
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 12px;
  color: #dfe9ff;
}
h1 {
  font-size: 2.6rem;
  font-weight: 700;
  margin-bottom: 16px;
}
.lead {
  font-size: 1.1rem;
  max-width: 680px;
  line-height: 1.8;
  color: #eef3ff;
}
.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}
.info-card,
.service-card {
  background: rgba(10, 24, 44, 0.86);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 14px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.2);
}
.info-card {
  padding: 24px;
}
.info-card h3 {
  font-size: 1.2rem;
  margin-bottom: 14px;
  color: white;
}
.info-card ul {
  padding-left: 18px;
  margin: 0;
  color: #e6ebf8;
  line-height: 1.9;
}
.content-section {
  padding: 0 0 60px;
}
.service-card {
  height: 100%;
  overflow: hidden;
}
.service-card img {
  width: 100%;
  height: 180px;
  object-fit: cover;
}
.service-card h4 {
  padding: 16px 16px 6px;
  color: white;
  font-size: 1.15rem;
}
.service-card p {
  padding: 0 16px 16px;
  color: #dfe6f7;
  line-height: 1.7;
}
.btn-outline-light {
  border-color: white;
  color: white;
}
.btn-outline-light:hover {
  background: white;
  color: #0f172a;
}
@keyframes backgroundMove {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
